import { ReactElement } from 'react';
import MarketplaceFooter from 'components/footer-marketplace/MarketplaceFooter';
import { Head } from 'components/head/Head';
import { getMarketContent } from 'utils/marketContent';
import ShopNavBar from './shop-nav-bar';
import HomeBanner from './home-banner';
import ShopBlogs from './shop-blogs';
import ProductsByTags from './product-by-tags';
import Partners from './partners';
import PromoParallax from './promo-parallax';
import PromoBanner from './promo-banner';
import Testimonials from './testimonials';
import NewArrivals from './new-arrivals';
import './shop-scss/shop-index.scss';

export default function ShopHomePage(): ReactElement {
  const market = getMarketContent();
  const data = market.meta;
  return (
    <>
      <Head title={data.title} link="/" keywords={data.title} />
      <ShopNavBar />
      <HomeBanner />
      <PromoBanner />
      <NewArrivals />
      <div className="container py-5 px-4 md:px-0">
        <div className="grid">
          <div className="col-12 md:col-9">
            <ShopBlogs />
          </div>
          <div className="col-12 md:col-3">
            <Testimonials />
          </div>
        </div>
      </div>
      <PromoParallax />
      <ProductsByTags />
      <Partners />
      <MarketplaceFooter />
    </>
  );
}
